export default __webpack_public_path__ + "static/media/DSC09950.138aef5b.JPG";